import React, { Dispatch, SetStateAction, useEffect, useRef } from "react";
import styled from "styled-components";
import Blank from "../../../DefaultStyles/Blank";
import { Textarea } from "../../../Input/Textarea";

interface TemplatePreviewBoxProps {
  previewValue?: string;
  inputValue: string;
  setInputValue: Dispatch<SetStateAction<string>>;
}

export default function TemplatePreviewBox({
  previewValue,
  inputValue,
  setInputValue,
}: TemplatePreviewBoxProps) {
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    if (textareaRef && textareaRef.current) {
      textareaRef.current.style.height = "0px";
      const scrollHeight = textareaRef.current.scrollHeight;
      textareaRef.current.style.height = scrollHeight + "px";
    }
  }, [inputValue]);

  return (
    <TemplatePreviewBoxContainer>
      <FixedBox>{previewValue?.split("#{alert_msg}")[0]}</FixedBox>

      {previewValue?.includes("#{alert_msg}") && (
        <AdditionalTextArea
          ref={textareaRef}
          placeholder="추가 내용 입력(필수)"
          autoFocus={true}
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          required={true}
          style={{ maxHeight: 290 }}
        />
      )}

      {previewValue?.split("#{alert_msg}")[1] && (
        <FixedBox>
          {previewValue?.split("#{alert_msg}")[1]?.replace("\r\n\r\n", "")}
        </FixedBox>
      )}

      <Blank blankHeight={24} />
    </TemplatePreviewBoxContainer>
  );
}

const TemplatePreviewBoxContainer = styled.div`
  height: auto;
  margin-bottom: 16px;
`;

export const FixedBox = styled.div`
  width: 100%;
  min-height: 40px;
  background-color: ${({ theme }) => theme.color.bgColor};
  padding: 16px;
  overflow-y: hidden;
  white-space: pre-line;
  line-break: anywhere;

  font-size: 14px;
  font-weight: 500;
  line-height: 21px;
  text-align: left;
  color: ${({ theme }) => theme.color.gray600};

  strong {
    font-weight: bold;
  }
`;

export const AdditionalTextArea = styled(Textarea)`
  background-color: white;
  border: 2px solid #00c7c7;
  border-radius: 0;

  &:not(:read-only) {
    &:focus {
      border-width: 2px;
    }
  }
`;
